// TIPTAP-TRIAL: Remove this file if we move away from Tiptap Cloud (AI / Paste Handler).
import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { map, tap } from 'rxjs/operators';

interface TiptapTokenResponse {
  token: string;
}

@Injectable({ providedIn: 'root' })
export class TiptapTokenApiService {

  private cachedToken: string | null = null;
  private cacheExpiresAt = 0;

  // Cache tokens for 90 minutes — well inside the 2-hour JWT expiry.
  private static readonly CACHE_TTL_MS = 90 * 60 * 1000;

  // HttpClient is @Optional so tests that don't import HttpClientModule don't fail.
  constructor(@Optional() private http: HttpClient) {}

  getToken(): Promise<string> {
    if (!this.http) return Promise.resolve('');

    const now = Date.now();
    if (this.cachedToken && now < this.cacheExpiresAt) {
      return Promise.resolve(this.cachedToken);
    }

    return this.fetchAndCache();
  }

  forceRefresh(): Promise<string> {
    this.cachedToken = null;
    this.cacheExpiresAt = 0;
    return this.fetchAndCache();
  }

  private fetchAndCache(): Promise<string> {
    if (!this.http) return Promise.resolve('');
    return firstValueFrom(
      this.http
        // Relative URL: this is our own backend on the same origin (ADR-STYLE-0001).
        .get<TiptapTokenResponse>('/api/tiptap/token')
        .pipe(
          map(r => r.token),
          tap(token => {
            this.cachedToken = token;
            this.cacheExpiresAt = Date.now() + TiptapTokenApiService.CACHE_TTL_MS;
          })
        )
    );
  }
}
